"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          background: "#0f1623",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          color: "#eff3ff",
          padding: "2rem",
          textAlign: "center",
        }}
      >
        <p
          style={{
            fontSize: "11px",
            fontWeight: 600,
            color: "#9d94f5",
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            fontFamily: "monospace",
            marginBottom: "1rem",
          }}
        >
          CloudBreach
        </p>
        <h1 style={{ fontSize: "2rem", fontWeight: 700, marginBottom: "0.75rem" }}>
          Something went wrong
        </h1>
        <p style={{ color: "#8b97b0", marginBottom: "2rem", maxWidth: "400px", lineHeight: 1.6 }}>
          A critical error occurred. Please try refreshing the page.
          {error.digest && (
            <span style={{ display: "block", fontSize: "12px", fontFamily: "monospace", marginTop: "0.5rem", color: "#4a5568" }}>
              Digest: {error.digest}
            </span>
          )}
        </p>
        <button
          onClick={reset}
          style={{
            background: "#9d94f5",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "0.75rem 1.5rem",
            fontSize: "14px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
